// Google Analytics 4 Configuration for MercadoTV
import ReactGA from 'react-ga4';

// Substituir pelo seu Measurement ID do Google Analytics
const TRACKING_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-V4JFY5GSN1';

export const initGA = () => {
  if (!TRACKING_ID || TRACKING_ID === 'G-XXXXXXXXXX') {
    console.warn('Google Analytics Tracking ID não configurado');
    return;
  }

  ReactGA.initialize(TRACKING_ID, {
    debug: process.env.NODE_ENV === 'development',
    titleCase: false,
    gaOptions: {
      send_page_view: false // Controlamos manualmente
    }
  });

  console.log('Google Analytics inicializado:', TRACKING_ID);
};

// Página vista
export const trackPageView = (path, title) => {
  if (!TRACKING_ID || TRACKING_ID === 'G-XXXXXXXXXX') return;
  
  ReactGA.send({ 
    hitType: 'pageview', 
    page: path,
    title: title || document.title
  });
  
  console.log('GA: Page view tracked:', path);
};

// Eventos personalizados
export const trackEvent = (action, category, label, value) => {
  if (!TRACKING_ID || TRACKING_ID === 'G-XXXXXXXXXX') return;
  
  ReactGA.event({
    action: action,
    category: category,
    label: label,
    value: value
  });
  
  console.log('GA: Event tracked:', { action, category, label, value });
};

// Eventos específicos do MercadoTV
export const trackProductView = (productId, productName, category) => {
  trackEvent('view_item', 'Produtos', `${productName} (${category})`, productId);
};

export const trackAddToInterest = (productId, productName) => {
  trackEvent('add_to_wishlist', 'Lista de Interesse', productName, productId);
};

export const trackRemoveFromInterest = (productId, productName) => {
  trackEvent('remove_from_wishlist', 'Lista de Interesse', productName, productId);
};

export const trackQuoteRequest = (products, totalValue) => {
  trackEvent('generate_lead', 'Conversões', 'Pedido de Orçamento', Math.round(totalValue || 0));
};

export const trackContactForm = (formType) => {
  trackEvent('contact_form_submit', 'Formulários', formType);
};

export const trackUserRegister = () => {
  trackEvent('sign_up', 'Utilizadores', 'Registo Novo Utilizador');
};

export const trackUserLogin = () => {
  trackEvent('login', 'Utilizadores', 'Login Utilizador');
};

export const trackCategoryView = (categoryName) => {
  trackEvent('view_item_list', 'Navegação', `Categoria: ${categoryName}`);
};

export const trackSearch = (searchTerm, results) => {
  trackEvent('search', 'Navegação', searchTerm, results);
};

export const trackError = (errorType, errorMessage) => {
  trackEvent('exception', 'Erros', `${errorType}: ${errorMessage}`);
};

// Enhanced E-commerce Events
export const trackPurchaseIntent = (products) => {
  const totalValue = products.reduce((sum, product) => sum + (product.price * product.quantity), 0);
  
  trackEvent('begin_checkout', 'E-commerce', 'Início do Processo de Orçamento', Math.round(totalValue));
};

export const trackEmailSent = (emailType) => {
  trackEvent('email_sent', 'Comunicação', emailType);
};

// Timing events
export const trackTiming = (category, variable, value, label) => {
  if (!TRACKING_ID || TRACKING_ID === 'G-XXXXXXXXXX') return;
  
  ReactGA.gtag('event', 'timing_complete', {
    name: variable,
    value: value,
    event_category: category,
    event_label: label
  });
};

// Custom dimensions (se configurado no GA4)
export const setUserProperties = (properties) => {
  if (!TRACKING_ID || TRACKING_ID === 'G-XXXXXXXXXX') return;
  
  ReactGA.gtag('config', TRACKING_ID, {
    custom_map: properties
  });
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackProductView,
  trackAddToInterest,
  trackRemoveFromInterest,
  trackQuoteRequest,
  trackContactForm,
  trackUserRegister,
  trackUserLogin,
  trackCategoryView,
  trackSearch,
  trackError,
  trackPurchaseIntent,
  trackEmailSent,
  trackTiming,
  setUserProperties
};
